import {Modal} from '../index';
import {useDispatch} from 'react-redux';
import {closeModuleModal, redeemComebackReward} from '../../../../reducers/modules/actions';
import {navigate} from '../../../../utils/navigation';

export default ({modal, data}) => {
    const dispatch = useDispatch();

    return (
        <Modal>
            <div className="creative-header" style={{
                background: `url(${window.location.origin}/source/modules/modals/comeback_reward/${modal.details.background}.png)`,
                backgroundSize: 'cover'
            }}>
                <div className="close" onClick={e => dispatch(closeModuleModal())}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18 18L6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> 
                </div>

                <div className="creative-shadow"></div>
            </div>

            <div className="modal-text" style={{marginTop: '-30px'}}>
                <div className="title">Welcome back!</div>
                <div className="description">Your comeback rewards are ready.</div>
            </div>

            <div className="block">
                <div className="limited-time">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.6668 8.00001C14.6668 11.68 11.6802 14.6667 8.00016 14.6667C4.32016 14.6667 1.3335 11.68 1.3335 8.00001C1.3335 4.32001 4.32016 1.33334 8.00016 1.33334C11.6802 1.33334 14.6668 4.32001 14.6668 8.00001Z"
                            stroke="#580AC9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M10.4734 10.12L8.40675 8.88665C8.04675 8.67332 7.75342 8.15999 7.75342 7.73999V5.00665"
                            stroke="#580AC9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                    Limited time offer
                </div>

                <div className="bonuses-list">
                    {modal.details.bonuses.freeplay && (
                        <div className="bonus freeplay">
                            <div className="background" style={{
                                backgroundImage: `url(${window.location.origin}/source/system/games/vertical/${modal.details.bonuses.freeplay.game}.png)`,
                                backgroundSize: '100%'
                            }}></div>
                            <div className="value">
                                <span>${modal.details.bonuses.freeplay.value}</span> Freeplay
                            </div>
                        </div>
                    )}

                    {modal.details.bonuses.deposit_boost && (
                        <div className="bonus deposit_boost">
                            <div className="background"></div>
                            <div className="value">
                                <span>{modal.details.bonuses.deposit_boost.value}%</span> Boost
                            </div>
                        </div>
                    )}

                    {modal.details.bonuses.diamonds && (
                        <div className="bonus diamonds">
                            <div className="background"></div>
                            <div className="value">
                                <span>{modal.details.bonuses.diamonds.value}</span> Diamonds
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-button blue" onClick={e => dispatch(redeemComebackReward({
                    bonusId: modal.details.bonus_id,
                    triggerId: modal.triggerId,
                    communicationId: modal.communicationId
                }))}>
                    {
                        !data.button 
                        ? 'Claim rewards'
                        : (
                            <div className="dots">
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                            </div>
                        )
                    }
                </div>
            </div>
        </Modal>
    )
} 